import { useFormContext, useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputProps, PhoneInput } from '../../UI';
import { PersonFormValues } from '../types';
import { FC } from 'react';
import { phoneRegex } from '../../UI';

type PersonPhoneNumberInputProps = Pick<InputProps, 'label' | 'className'> & InputProps['inputProps'];

export const PersonPhoneNumberInput: FC<PersonPhoneNumberInputProps> = ({
  label,
  required,
  className,
  ...inputProps
}) => {
  const { t: tForm } = useTranslation('form');
  const {
    formState: { errors },
    control,
  } = useFormContext<PersonFormValues>();

  const phoneController = useController<PersonFormValues, 'phoneNumber'>({
    name: 'phoneNumber',
    control: control,
    rules: {
      validate: (phoneNumber) => (phoneNumber ? phoneRegex.test(phoneNumber) : true),
    },
  });

  return (
    <PhoneInput
      className={className}
      {...phoneController.field}
      status={errors.phoneNumber ? 'errored' : 'normal'}
      inputProps={{
        placeholder: required ? tForm('general-required-placeholder') : '',
        ...inputProps,
        defaultValue: phoneController.field?.value?.slice(1) ?? '',
      }}
    />
  );
};
